import * as React from 'react';
import * as registration from './style.module.scss';
import { TaxDeduction } from '../../../../TaxDeduction';
export const Registration = ({ widget, sravni }) => {
  return (
    <section className={registration.registration} id={'reg'}>
      <div className={'container'}>
        <div className={registration.registration__wrap}>
          <div className={registration.registration__info}>
            <div className={registration.registration__top}>
              <h2 className={registration.registration__title}>Стоимость тренинга</h2>
              <span className={`${registration.registration__text} ${registration.registration__textLineThrough}`}>
                69&nbsp;900&nbsp;₽
              </span>
              <span className={`${registration.registration__text} ${registration.registration__textAccent}`}>
                54&nbsp;900&nbsp;₽
              </span>
              <span className={`${registration.registration__text} ${registration.registration__textSmall}`}>
                Скидка: 15&nbsp;000&nbsp;₽
              </span>
            </div>

            <div className={registration.registration__bottom}>
              <span className={`${registration.registration__text} ${registration.registration__textSubtitle}`}>
                Оплата по&nbsp;месяцам без переплаты
              </span>
              <span className={`${registration.registration__text} ${registration.registration__textAccent}`}>
                5&nbsp;490&nbsp;₽
                <span
                  className={`${registration.registration__text} ${registration.registration__textAccent} ${registration.registration__textSmall2}`}
                >
                  /месяц
                </span>
              </span>
              <span className={`${registration.registration__text} ${registration.registration__textSmall}`}>
                на&nbsp;10&nbsp;месяцев
              </span>
            </div>

            <p className={registration.extra}>Доступ к курсу на&nbsp;1&nbsp;год</p>
            <TaxDeduction className={registration.extra} linkInner={sravni} />
          </div>

          <div className={registration.registration__widget} id={'widget'}>
            {widget}
          </div>
        </div>
      </div>
    </section>
  );
};
